<span class="mat-content" [class.mat-content-hide-toggle]="!_showToggle()">
  <ng-content select="mat-panel-title"></ng-content>
  <ng-content select="mat-panel-description"></ng-content>
  <ng-content></ng-content>
</span>
<span [@indicatorRotate]="_getExpandedState()" *ngIf="_showToggle()"
      class="mat-expansion-indicator"></span>



// WEBPACK FOOTER //
// ../../../../../src/material/expansion/expansion-panel-header.html